function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11 13.75c0-.413-.338-.75-.75-.75h-3.75v3c0 .552-.448 1-1 1s-1-.448-1-1v-3h-3.75c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75h9.5c.412 0 .75-.337.75-.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m24 13.75c0-.413-.338-.75-.75-.75h-3.75v3c0 .552-.448 1-1 1s-1-.448-1-1v-3h-3.75c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75h9.5c.412 0 .75-.337.75-.75z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.5.75c0-.412-.338-.75-.75-.75h-3.75v3c0 .552-.448 1-1 1s-1-.448-1-1v-3h-3.75c-.413 0-.75.338-.75.75v9.5c0 .413.337.75.75.75h9.5c.412 0 .75-.337.75-.75z"
});

var SvgShipping = function SvgShipping(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShipping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shipping.b3742a87.svg";
export { ForwardRef as ReactComponent };